import React, { useState, useEffect } from "react";
import $ from 'jquery';
import { Select, Checkbox } from 'react-materialize';
import Html from "../../utils/Html";

export default function FilterStatus({data, filters}) {
    data = [{name: "YES", id: "Y"}, {name: "NO", id: "N"}];
    const [statusFilters, setStatusFilters] = useState({
        data: filters.data, 
        key_form: filters.key_form, 
        checked: false,
        disable: filters.disable
    });
    let handleEvents = {
        OnChange : function(evt){
            
        }
    };
    useEffect(() => {
        
    }, []);
    //console.log("Filter Status");
    return <div key={"filter-status" + statusFilters.key_form} className="filter-input-field select" id="filter-status">
        <Select 
            multiple={false} 
            key={"filter-inp-status" + statusFilters.key_form}
            id="filter-inp-status" 
            name="status" 
            options={{
                classes: '',
                dropdownOptions: {
                    alignment: 'left',
                    autoTrigger: true,
                    closeOnClick: false,
                    constrainWidth: true,
                    coverTrigger: false,
                    hover: false,
                    inDuration: 150,
                    onCloseEnd: null,
                    onCloseStart: null,
                    onOpenEnd: null,
                    onOpenStart: null,
                    outDuration: 250
                }
            }}
            defaultValue={statusFilters.data}
            onChange={handleEvents.OnChange}
            disabled={statusFilters.disable}
        >
            <Html.Options data={data} addon={{
                key: "status", 
                name: "name", 
                value: "id",
                title: "Status"
            }} />   
        </Select>
        <span className="select-helper-text hide" id="helper-text-status">Please select status</span>
    </div>
}